import { Controller } from '@hotwired/stimulus';

var Highcharts = require('highcharts');
// Load module after Highcharts is loaded
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/accessibility')(Highcharts);

export default class extends Controller {
  static targets = ['chart'];
  // [low, medium, high]
  static values = {
    highTranslation: String,
    intensityData: Array,
    lowTranslation: String,
    mediumTranslation: String,
    minutesTranslation: String,
    locale: String,
    viewFullscreenTranslation: String,
    printChartTranslation: String,
    downloadPngImageTranslation: String,
    downloadJpgImageTranslation: String,
    downloadPdfTranslation: String,
    downloadSvgTranslation: String
  };

  connect() {
    const chart = Highcharts.chart('minutesWalkedChart', {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      accessibility: {
        description: 'minutes walked pie chart'
      },
      lang: {
        locale: this.localeValue,
        printChart: this.printChartTranslationValue,
        viewFullscreen: this.viewFullscreenTranslationValue,
        downloadPNG: this.downloadPngImageTranslationValue,
        downloadJPEG: this.downloadJpgImageTranslationValue,
        downloadPDF: this.downloadPdfTranslationValue,
        downloadSVG: this.downloadSvgTranslationValue
      },
      title: {
        text: ''
      },
      plotOptions: {
        pie: {
          allowPointSelect: false,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            distance: -30,
            color: '#FFFFFF',
            format: '{y}',
            style: {
              fontSize: '25px'
            }
          },
          slicedOffset: 20,
          showInLegend: true
        }
      },
      series: [
        {
          name: this.minutesTranslationValue,
          colorByPoint: true,
          data: [
            {
              name: this.lowTranslationValue,
              color: '#DC1D0D',
              y: this.intensityDataValue[0]
            },
            {
              name: this.mediumTranslationValue,
              color: '#ffc125',
              y: this.intensityDataValue[1]
            },
            {
              name: this.highTranslationValue,
              y: this.intensityDataValue[2],
              color: '#00A006'
            }
          ]
        }
      ]
    });

    chart.series[0].points.forEach((point) => {
      if (point.y === 0) {
        point.setVisible(false);
      }
    });
  }
}
